import { render, staticRenderFns } from "./InventoryMaterials.vue?vue&type=template&id=f4a0bd5c&scoped=true"
import script from "./InventoryMaterials.vue?vue&type=script&lang=js"
export * from "./InventoryMaterials.vue?vue&type=script&lang=js"
import style0 from "./InventoryMaterials.vue?vue&type=style&index=0&id=f4a0bd5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a0bd5c",
  null
  
)

export default component.exports